module.exports = __webpack_public_path__ + "img/123.dff8b5a0.jpg";